import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  overflow-x: auto;
  margin-bottom: 20px;
  gap: 10px;
`

type PageWrapperProps = {
  $selected?: boolean
  $isWide?: boolean
  $isStatic?: boolean
}

export const PageWrapper = styled.button<PageWrapperProps>`
  cursor: ${({ $isStatic }) => ($isStatic ? 'default' : 'pointer')};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ $isWide }) => ($isWide ? '0 14px' : '0')};
  border-radius: ${({ $isWide }) => ($isWide ? '30px' : '50%')};
  width: ${({ $isWide }) => ($isWide ? 'auto' : '40px')};
  height: 40px;
  min-width: ${({ $isWide }) => ($isWide ? '80px' : '40px')};
  font-weight: 400;
  text-align: center;
  font-size: ${({ theme }) => theme.text.pMini.fontSize};
  line-height: ${({ theme }) => theme.text.pMini.lineHeight};
  box-sizing: border-box;
  white-space: nowrap;
  background: ${({ $selected, theme }) =>
    $selected ? theme.colors.main : 'none'};
  color: ${({
    $selected,
    theme: {
      colors: {
        text: { surface },
      },
    },
  }) => ($selected ? surface : 'black')};
  border: 1px solid ${({ $selected, theme }) =>
    $selected ? theme.colors.main : '#c4c4c4'};
  font-family: inherit;

  &:hover {
    background: ${({ $isStatic, theme }) =>
      $isStatic ? 'none' : theme.colors.main};
    color: ${({ $isStatic, theme }) =>
      $isStatic ? 'black' : theme.colors.text.surface};
    border-color: ${({ $isStatic, theme }) =>
      $isStatic ? '#c4c4c4' : theme.colors.main};
  }
`
